/**
 * 创建人：袁俊双
 * 时间：2020-10-20
 * 描述：级联选择器
 * 使用说明: 参考 sw-cascader-select 配置应用说明文档
 */
import { Component, OnInit, Input, forwardRef, ElementRef, Output, EventEmitter, ComponentFactoryResolver, Injector, ApplicationRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { SwCascaderSelectBoxComponent } from './sw-cascader-select-box/sw-cascader-select-box.component';

export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SwCascaderSelectComponent),
  multi: true
};
@Component({
  selector: 'sw-cascader-select',
  templateUrl: './sw-cascader-select.component.html',
  styleUrls: ['./sw-cascader-select.component.css'],
  providers: [EXE_COUNTER_VALUE_ACCESSOR]
})
export class SwCascaderSelectComponent implements ControlValueAccessor, OnInit {

  /**
   * 树绑定数据 格式{"id": "1", "text": "content", "pid": "0"}
   */
  @Input() datas: any[];  

  /**
   * 不要展示的节点(包括其子节点)的id
   */
  @Input() disabledNodeId:string = "";

  /**
   * 能展示但是不能选择的节点(包括其子节点)的id
   */
  @Input() readonlyNodeId:any[] = []  

  /**
   * 能展示但是不能选择的节点(不包括其子节点)的id
   */
  @Input() readonlySelfId:any[]  = []

  /**
   * 最底层节点带复选框
   */
  @Input() selectChildren: boolean = false;

  /**
   * 所有节点带复选框
   */
  @Input() allCanCheck: boolean = false;  

  /**
   * 复选功能回显的id
   */
  multiNodeIds: any[] = []; 

  /**
   * 禁用
   */
  @Input() disabled:boolean =false;  
  
  /**
   * 绑定的参数 保存的参数值
   */
  @Input() value:string ="id"  

  /**
   * 下拉框固定高度
   */
  @Input() height:string ="150px" 

  /**
   * 下拉框固定每个面板的宽度
   */
  @Input() width:string ="180px" 

  /** 
   * 单选选择任意一级选项
   */
  @Input() radio: boolean = false

  /**
   * 下拉树单选功能选中后展示效果,比如: 选中'墨葡科技' 后,input输入框中展示: '组织 / 数文科技 / 墨葡科技'
   */
  @Input() showFather:boolean = false

  /**
   * 下拉树未选择时 提示信息
   */
  @Input() placeholder:string = ''

  /**
   * 异步加载的请求地址，没有则为同步加载
   */
  @Input() asyncUrl: string;

  /**
   * 输出属性,将选中的节点抛出
   */
  @Output() changClick  = new EventEmitter();

  /**
   * 输入框
   */
  @ViewChild('input') input:ElementRef;


    /** 
   * 单选选择,抛出文字是否是斜杠 /   否为  >
   */
  @Input() isXie: boolean = true

  /** 
   * 显示完整路径时是否隐藏根节点(如行政区划的"全国"),从根的子节点开始显示
   */
  @Input() hideRoot: boolean = false


  /**
   *  @ignore
   *  展现关闭下拉
   */
  swTreeSelectComponentRef:any;

  /**
   * input显示内容(单选)
   * @ignore
   */
  text:string;  

  /**
   * 多选--选中的节点
   * @ignore
   */
  multiNodes:any[] = [];  

  /**
   * 双向绑定id值
   * @ignore
   */
  _id: string;  
  
  parentArr:any[] = []

  /**
   * @ignore
   */
  get Id() {   
    return this._id;
  }

  /**
   * @ignore
   */
  set Id(value: string) {
    this._id = value;
    this.propagateChange(this._id);
  }

  /**
   * @ignore
   */
  propagateChange = (_: any) => {};

  /**
   * ngModeul 双向绑定数据
   * @ignore
   * @param value 
   */
  writeValue(value: string): void {
    if (value) {
      this.Id = value;
      if(this.selectChildren || this.allCanCheck){
        this.multiNodes = []
        //如果是多选，双向绑定的值就是id组成的字符串，逗号隔开
        this.multiNodeIds = value.split(",")
        //根据选中的ids找到对应的节点
        this.multiNodeIds.forEach(id=>{
          let index = this.datas.findIndex(m=>m.id == id)
          if(index != -1){
            this.multiNodes.push(this.datas[index])
          }
        })
        if(this.showFather){    //如果指定了输入框的展示效果,就要对text进行处理再展示
          this.multiNodes.forEach(n=>{
            let node = this.datas.filter(x => x[this.value]==n.id);
            this.parentArr = [node[0]]
            this.findFarent(node[0])
            let textArr = this.parentArr.map(v=>v.text)  //[选中项,选中项父节点,选中项祖节点]
            textArr = textArr.reverse()
            if(this.hideRoot){ textArr.shift(); } // 隐藏根节点,从根的子节点开始显示
           // n.textAll = textArr.join(' / ')
             if(this.isXie){
                n.textAll = textArr.join(' / ')
                }else {
                  n.textAll = textArr.join(' > ')
                }
          })
        }
        //记录上一次改变时组件的高度
        let preHeight = this.el.nativeElement.querySelector(".inputbox").offsetHeight
        //多选结果多了,超过一行,就将输入框变高
        let timer2 = setTimeout(() => {
          let height1
          if(this.multiNodes.length){
            height1 = this.el.nativeElement.querySelector(".sw-select-multi-cont").offsetHeight
            
          } else {
            //没有 div.sw-select-multi-cont 
            height1 = 34
          }
          this.el.nativeElement.querySelector(".inputbox").style.height = height1 + 'px'
          this.el.nativeElement.querySelector(".form-control").style.height = height1 + 'px'
          if(!this.multiNodes.length){  //减少的时候,如果最后没有选中项,要有最小的高度
            this.el.nativeElement.querySelector(".inputbox").style.height = preHeight + 'px'
            this.el.nativeElement.querySelector(".form-control").style.height = preHeight + 'px'
          }
          clearTimeout(timer2)
        }, 0);
      } else {
        //单选
        this.Id = value;
        if(this.datas){
          let node = this.datas.filter(x => x[this.value]==value);
          //如果绑定返回值为id
          if(this.value == 'id') {
            if (node.length>0) {
              this.Id = node[0].id;
              this._id = node[0].id;
              if(this.showFather){    //如果指定了输入框的展示效果,就要对text进行处理再展示
                this.parentArr = [node[0]]
                this.findFarent(node[0])
                let textArr = this.parentArr.map(v=>v.text)  //[选中项,选中项父节点,选中项祖节点]
                textArr = textArr.reverse()
                if(this.hideRoot){ textArr.shift(); } // 隐藏根节点,从根的子节点开始显示
                //this.text = textArr.join(' / ')
                  if(this.isXie){
                this.text = textArr.join(' / ')
                }else {
                  this.text = textArr.join(' > ')
                }
              } else {
                this.text = node[0].text;
              }
              
            }
          }else{
            //绑定返回值不为id
            if (node.length>0) {
              this.Id = node[0][this.value];
              this._id = node[0][this.value];
              if(this.showFather){  //如果指定了输入框的展示效果,就要对text进行处理再展示
                this.parentArr = [node[0]]
                this.findFarent(node[0])
                let textArr = this.parentArr.map(v=>v.text)  //[选中项,选中项父节点,选中项祖节点]
                textArr = textArr.reverse()
                if(this.hideRoot){ textArr.shift(); } // 隐藏根节点,从根的子节点开始显示
               // this.text = textArr.join(' / ')
                   if(this.isXie){
                this.text = textArr.join(' / ')
                }else {
                  this.text = textArr.join(' > ')
                }
              } else {
                this.text = node[0].text;
              }
              
            }
          }
        }
      }
    
    }
    else{
      this._id = value;
      this.text = "";
    }
  }

  /**
   * 多选--每个选择数据的单个删除事件
   * @param text 删除的对象
   * @ignore
   */
  closetigger(event,node) {
    event.stopPropagation()
    let index = this.multiNodes.findIndex(v=>v.id == node.id)
    if(index != -1){
      this.multiNodes.splice(index,1)
      this.multiNodeIds.splice(index,1)
    }
    
    this.Id = this.multiNodeIds.join(',')
    this.changClick.emit(this.multiNodes);
    //记录上一次改变时组件的高度
    let preHeight = this.el.nativeElement.querySelector(".inputbox").offsetHeight
    //多选结果多了,超过一行,就将输入框变高
    let timer2 = setTimeout(() => {
      let height1
      if(this.multiNodes.length){
        height1 = this.el.nativeElement.querySelector(".sw-select-multi-cont").offsetHeight
        
      } else {
        //没有 div.sw-select-multi-cont 
        height1 = 34
      }
      this.el.nativeElement.querySelector(".inputbox").style.height = height1 + 'px'
      this.el.nativeElement.querySelector(".form-control").style.height = height1 + 'px'
      if(!this.multiNodes.length){  //减少的时候,如果最后没有选中项,要有最小的高度
        this.el.nativeElement.querySelector(".inputbox").style.height = preHeight + 'px'
        this.el.nativeElement.querySelector(".form-control").style.height = preHeight + 'px'
      }
      clearTimeout(timer2)
    }, 0);
  }

  clickFocus(){
    this.input.nativeElement.focus()
  }

  /**
   * @ignore
   * @param node,该参数可能是 datas中的数据,还是 id,pid,text这个格式,页可能是选中之后传来的node,是key,parent,title这样的格式,处理时需要注意,但是获取到的父节点的数据格式都是前者
   */
  
  findFarent(node: any): void {
    let pid = node.pid || node.parent
    if(pid){
      let p = this.datas.filter(x => x.id==pid)
      if(p.length){
        this.parentArr.push(p[0])
        if(p[0].pid){
          this.findFarent(p[0])
        }
      }
    }
  }


  /**
   * @ignore
   * @param fn 
   */
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  /**
   * @ignore
   * @param fn 
   */
  registerOnTouched(fn: any): void {
  }

  /**
   * @ignore
   * @param isDisabled 
   */
  setDisabledState?(isDisabled: boolean): void {
  }

  /**
   * 唯一主键
   * @ignore
   */
  ids:string

  /**
   * @ignore
   * @param el 
   * @param componentFactoryResolver 
   * @param injector 
   * @param applicationRef 
   */
  constructor(
    private el :ElementRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private applicationRef: ApplicationRef,) { }

  /**
   * @ignore
   */
  ngOnInit() { }

  /**
   * 开启或关闭下拉框
   * @ignore
   */
  dropdown: boolean = false;

  /**
   * 打开选中框
   * @param event
   * @ignore 
   */
  open(event){
    const com = document.createElement(SwCascaderSelectBoxComponent.name);
    //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwCascaderSelectBoxComponent);
    this.swTreeSelectComponentRef = factory.create(this.injector, [], com);
    this.applicationRef.attachView(this.swTreeSelectComponentRef.hostView);
    // 弹出下拉框
    this.dropdown = true;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["ids"] = this.ids;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["elem"] = this.el;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["dropdown"] = this.dropdown;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["height"] = this.height;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["width"] = this.width;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["keySelected"] = this.Id;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["disabledNodeId"] = this.disabledNodeId;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["readonlyNodeId"] = this.readonlyNodeId;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["readonlySelfId"] = this.readonlySelfId;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["datas"] = this.datas; 
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["radio"] = this.radio;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["asyncUrl"] = this.asyncUrl;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["selectChildren"] = this.selectChildren;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["allCanCheck"] = this.allCanCheck;
    // 给组件传递参数
    this.swTreeSelectComponentRef.instance["multiNodeIds"] = this.multiNodeIds;
    // 给组件传递回调函数
    this.swTreeSelectComponentRef.instance["closeSelect"].subscribe(data => {
      // 失去焦点
      this.input.nativeElement.blur()
      if (data) {
        // 如果有参数传递出来，就执行回调
        this.voted(data);
      }
      try {
        // 移除dom
        document.body.removeChild(com);
        this.applicationRef.detachView(this.swTreeSelectComponentRef.hostView);
        // 销毁组件
        this.swTreeSelectComponentRef.destroy()
      } catch (e) { }

    });

    this.swTreeSelectComponentRef.instance["changeClick"].subscribe(data => {
      try {
        // 有参数就触发此事件
        this.updateSelected(data)
      } catch (e) { }

    });
    // 将组件追加到dom中去
    document.body.appendChild(com);
  }

  /**
   * 关闭选中框
   * @ignore
   */
  close(event) {
    this.swTreeSelectComponentRef.instance.close()
  }

  /**
   * 多选改变事件
   * @ignore
   * @param node 
   */
  updateSelected(node){
    this.multiNodes = node.map(v=>v.data)
    this.multiNodeIds = node.map(v=>v.key)
    this.Id = this.multiNodeIds.join(',')
    this.changClick.emit(this.multiNodes)
    if(this.showFather){    //如果指定了输入框的展示效果,就要对text进行处理再展示
      this.multiNodes.forEach(n=>{
        let node = this.datas.filter(x => x[this.value]==n.id);
        this.parentArr = [node[0]]
        this.findFarent(node[0])
        let textArr = this.parentArr.map(v=>v.text)  //[选中项,选中项父节点,选中项祖节点]
        textArr = textArr.reverse()
        if(this.hideRoot){ textArr.shift(); } // 隐藏根节点,从根的子节点开始显示
       // n.textAll = textArr.join(' / ')
           if(this.isXie){
                n.textAll = textArr.join(' / ')
                }else {
                  n.textAll = textArr.join(' > ')
                }
      })
    }
    //记录上一次改变时组件的高度
    let preHeight = this.el.nativeElement.querySelector(".inputbox").offsetHeight
    //多选结果多了,超过一行,就将输入框变高
    let timer2 = setTimeout(() => {
      let height1
      if(this.multiNodes.length){
        height1 = this.el.nativeElement.querySelector(".sw-select-multi-cont").offsetHeight
        
      } else {
        //没有 div.sw-select-multi-cont 
        height1 = 34
      }
      this.el.nativeElement.querySelector(".inputbox").style.height = height1 + 'px'
      this.el.nativeElement.querySelector(".form-control").style.height = height1 + 'px'
      if(!this.multiNodes.length){  //减少的时候,如果最后没有选中项,要有最小的高度
        this.el.nativeElement.querySelector(".inputbox").style.height = preHeight + 'px'
        this.el.nativeElement.querySelector(".form-control").style.height = preHeight + 'px'
      }
      clearTimeout(timer2)
    }, 0);
    
  }

  /**
   * 选择事件
   * @ignore
   * @param node 
   */
  voted(node,type?:string){
    if(this.selectChildren || this.allCanCheck){
      //如果是多选
      this.multiNodes = node.map(v=>v.data)
      this.multiNodeIds = node.map(v=>v.key)
      this.Id = this.multiNodeIds.join(',')
      this.changClick.emit(this.multiNodes)
      if(this.showFather){    //如果指定了输入框的展示效果,就要对text进行处理再展示
        this.multiNodes.forEach(n=>{
          let node = this.datas.filter(x => x[this.value]==n.id);
          this.parentArr = [node[0]]
          this.findFarent(node[0])
          let textArr = this.parentArr.map(v=>v.text)  //[选中项,选中项父节点,选中项祖节点]
          textArr = textArr.reverse()
          if(this.hideRoot){ textArr.shift(); } // 隐藏根节点,从根的子节点开始显示
         // n.textAll = textArr.join(' / ')
           if(this.isXie){
                n.textAll = textArr.join(' / ')
                }else {
                  n.textAll = textArr.join(' > ')
                }
        })
      }
      //记录上一次改变时组件的高度
      let preHeight = this.el.nativeElement.querySelector(".inputbox").offsetHeight
      //多选结果多了,超过一行,就将输入框变高
      let timer2 = setTimeout(() => {
        let height1
        if(this.multiNodes.length){
          height1 = this.el.nativeElement.querySelector(".sw-select-multi-cont").offsetHeight
          
        } else {
          //没有 div.sw-select-multi-cont 
          height1 = 34
        }
        this.el.nativeElement.querySelector(".inputbox").style.height = height1 + 'px'
        this.el.nativeElement.querySelector(".form-control").style.height = height1 + 'px'
        if(!this.multiNodes.length){  //减少的时候,如果最后没有选中项,要有最小的高度
          this.el.nativeElement.querySelector(".inputbox").style.height = preHeight + 'px'
          this.el.nativeElement.querySelector(".form-control").style.height = preHeight + 'px'
        }
        clearTimeout(timer2)
      }, 0);
    }else {
      //如果是单选
      //设置id
      this.Id = node.data[this.value];
      //设置 text
      if(this.showFather){  //如果指定了输入框的展示效果,就要对text进行处理再展示
        this.parentArr = []  //注意此处的node的格式是 key , parent, title这样的,与之后找到的父节点的格式不一样,所以单独处理
        this.findFarent(node)  //需要从datas中找到该节点的父节点
        let textArr = this.parentArr.map(v=>v.text)  //[选中项父节点,选中项祖节点]
        textArr = textArr.reverse()  //[选中项祖节点,选中项父节点]
        if(this.hideRoot){ textArr.shift(); } // 隐藏根节点,从根的子节点开始显示
        //将自己的节点的title加到数组中
        textArr.push(node.title)  //[选中项祖节点,选中项父节点,当前节点]
        if(this.isXie){
         this.text = textArr.join(' / ')
        }else {
          this.text = textArr.join(' > ')
        }
        
      } else {
        this.text = node.title;
      }
      //设置抛出数据
      this.changClick.emit(node);
    }
  }

  /**
   * 传递参数发生变化的时候触发
   * @ignore
   */
  ngOnChanges(){
    //放置先获取到选择数据
    //后获取到数据集的问题 
    //判断数据集合 选择数据都不为空的情况下选中数据
    if(this.datas ==null || this.datas == undefined)
      return;
      
    if(this.datas.length>0){
      if(this.Id!=null && this.Id!=undefined && this.Id!=""){
        let node = this.datas.filter(x => x[this.value]==this.Id);
        if (node.length>0) {
          this.Id = node[0][this.value];
          if(this.showFather){  //如果指定了输入框的展示效果,就要对text进行处理再展示
            this.parentArr = [node[0]]
            this.findFarent(node[0])
            let textArr = this.parentArr.map(v=>v.text)  //[选中项,选中项父节点,选中项祖节点]
            textArr = textArr.reverse()
            if(this.hideRoot){ textArr.shift(); } // 隐藏根节点,从根的子节点开始显示
           // this.text = textArr.join(' / ')
             if(this.isXie){
              this.text = textArr.join(' / ')
              }else {
                this.text = textArr.join(' > ')
              }
          } else {
            this.text = node[0].text;
          }
          
        }
      }
    }
  }

  /**
   * 清空选中
   * @ignore
   */
  clearSelect(){
    if(this.selectChildren || this.allCanCheck){
      //多选
      this.Id = "";
      this.text ="";
      this.multiNodes = []
      this.multiNodeIds = []
      // 抛出空数组
      this.changClick.emit([])
      //清空所有的选中项之后,将组件高度还原
      this.el.nativeElement.querySelector(".sw-select-multi-cont").style.height = '0px'
      this.el.nativeElement.querySelector(".inputbox").style.height = '34px'
      this.el.nativeElement.querySelector(".form-control").style.height = '34px'
    } else {
      //单选
      this.Id = "";
      this.text ="";
    }
  }

  //点击右侧三角图标
  //点击右侧三角图标
  switchDropmenu(event){
    event.stopPropagation(); //禁止冒泡
    if(!this.dropdown){ 
      //如果this.dropdown 为false,说明没有展开下拉框,此时需要展开下拉框
      this.input.nativeElement.focus()
    }  else {
      //此时已经自动触发了 blur 事件,下拉框已销毁, 需要将 this.dropdown 设置为false
      this.dropdown = false
    }
  }

}
